import ExerciseCard from './ExerciseCard';

export default ExerciseCard;
